import { render } from "./Diet.vue?vue&type=template&id=79ff6b59&scoped=true"
import script from "./Diet.vue?vue&type=script&lang=js"
export * from "./Diet.vue?vue&type=script&lang=js"

import "./Diet.vue?vue&type=style&index=0&id=79ff6b59&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79ff6b59"]])

export default __exports__